import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.context.request.user.is_authenticated
        ? _c(
            VBtn,
            {
              attrs: {
                small: "",
                elevation: "0",
                color: "bg-primary",
                href: _setup.authenticatedData.href,
              },
            },
            [
              _c(
                VIcon,
                {
                  staticClass: "mr-2",
                  attrs: { color: "primary", size: "20" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.authenticatedData.icon) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.translate("Личный кабинет")) +
                    "\n    "
                ),
              ]),
            ],
            1
          )
        : _c(
            VMenu,
            {
              attrs: {
                left: "",
                bottom: "",
                "offset-y": "",
                "max-width": "300",
                "nudge-bottom": "16",
                "close-on-content-click": false,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                small: "",
                                color: "bg-primary",
                                elevation: "0",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("div", { staticClass: "primary--text" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_setup.translate("Войти")) +
                                "\n        "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _setup.isActiveLogin,
                callback: function ($$v) {
                  _setup.isActiveLogin = $$v
                },
                expression: "isActiveLogin",
              },
            },
            [
              _vm._v(" "),
              _c(
                VSheet,
                { staticClass: "pa-4" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "text-subtitle-1 text--text mb-2" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.translate("Пациент")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text-caption text-secondary--text mb-2",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _setup.translate(
                                  "Делитесь отзывами о врачах, записывайтесь на приём онлайн, ведите электронную медкарту"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            small: "",
                            elevation: "0",
                            color: "primary",
                            href: _setup.patientAuthPath,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.translate("Войти")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(VDivider, { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "text-subtitle-1 text--text mb-2" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.translate("Врач или клиника")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text-caption text-secondary--text mb-2",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _setup.translate(
                                  "Отвечайте на отзывы пациентов, включайте запись на приём, рассказывайте о ваших услугах"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          attrs: {
                            small: "",
                            elevation: "0",
                            color: "primary",
                            href: _setup.profileAuthPath,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.translate("Войти")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }